{
  "backToLogin": "Back to sign-in",
  "confirmPassword": "Repeat the password",
  "displayName": "Your name",
  "email": "Email",
  "password": "Password",
  "passwordMismatch": "The passwords do not match."
}
